
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getFluencyTestResults",
      resolverType: "query",
      routePath: "/getFluencyTestResults",
      httpMethod: "POST",
    });
  